/**
 * Filtering and sorting. The form already works as a plain GET submit, and
 * every filter state is a real URL — this only replaces the page reload
 * with a fetch of the same URL, keeping the address bar and history in
 * sync so Back still does the obvious thing.
 */
(function () {
  'use strict';

  function init(root) {
    root.querySelectorAll('[data-facets-form]').forEach(function (form) {
      if (form.dataset.facetsInit) return;
      form.dataset.facetsInit = 'true';

      var section = form.closest('.shopify-section') || document;
      var results = section.querySelector('[data-collection-results]') ||
        document.querySelector('[data-collection-results]');
      if (!results) return;

      var panel = form.querySelector('[data-facets-panel]');
      var toggle = form.querySelector('[data-facets-toggle]');
      var controller = null;

      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          form.classList.toggle('is-open', !open);
        });
      }

      function apply() {
        var params = new URLSearchParams(new FormData(form));

        /* Empty values would otherwise become "?filter.v.price.gte=" and
           read as a real, empty filter. */
        Array.from(params.keys()).forEach(function (key) {
          if (params.getAll(key).every(function (value) { return value === ''; })) {
            params.delete(key);
          }
        });

        var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');

        if (controller) controller.abort();
        controller = new AbortController();
        results.classList.add('is-loading');

        fetch(url, { signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('Filter request failed');
            return response.text();
          })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('[data-collection-results]');
            var freshForm = parsed.querySelector('[data-facets-form]');
            if (fresh) results.innerHTML = fresh.innerHTML;
            if (freshForm && panel) {
              var freshPanel = freshForm.querySelector('[data-facets-panel]');
              if (freshPanel) panel.innerHTML = freshPanel.innerHTML;
            }
            history.pushState({ facets: true }, '', url);
            results.classList.remove('is-loading');
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            results.classList.remove('is-loading');
            window.location.href = url; // fall back to the plain navigation
          });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        apply();
      });

      form.addEventListener('change', function (event) {
        if (event.target.matches('input[type="checkbox"], select')) apply();
      });

      window.addEventListener('popstate', function () {
        window.location.reload();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
